module.exports = __webpack_public_path__ + "static/media/daily late report.421a07e0.svg";